import { Divider, Field, Input, makeStyles } from '@fluentui/react-components';
import React, { useEffect, useState } from 'react';
import Widget from '../parts/Widget';



const useStyles = makeStyles({
    fields: {
        display: "flex",
    },
    height40: {
        maxHeight: "80px",
    }
})

const WidgetPage = () => {
    const styles = useStyles();
    const [title, setTitle] = useState<string>();
    const [maker, setMaker] = useState<string>();
    const [brand, setBrand] = useState<string>();
    const [item, setItem] = useState<string>();

    useEffect(() => {
        setTitle("Widgetタイトル");
    }, []);


    return (
        <>
            <h2> Widgetのサンプル</h2>
            <Divider></Divider>
            <div className={styles.fields}>
                <Field
                    content='Widgetタイトル'
                >
                    <Input
                        value={title}
                        placeholder='Widgetタイトル'
                        onChange={(e, data) => {
                            setTitle(data.value);
                        }}
                    ></Input>
                </Field>


                <Field
                    content='メーカー'
                >
                    <Input
                        value={maker}
                        placeholder='メーカー'
                        onChange={(e, data) => {
                            setMaker(data.value);
                        }}
                    />
                </Field>
                <Field
                    content='ブランド'>
                    <Input
                        value={brand}
                        placeholder='ブランド'
                        onChange={(e, data) => {
                            setBrand(data.value);
                        }}
                    />
                </Field>
                <Field
                    content='商品名'>
                    <Input
                        value={item}
                        placeholder='商品名'
                        onChange={(e, data) => {
                            setItem(data.value);
                        }}
                    />
                </Field>

            </div >
            <Divider vertical className={styles.height40}>
                widget
            </Divider>
            <Widget
                title={title}
                maker={maker}
                brand={brand}
                item={item}
            ></Widget>
        </>
    );

}
export default WidgetPage;